/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/fetch";
import type { GetPdfStatusQueryResponse, GetPdfStatusPathParams, GetPdfStatus422 } from "../models/pdfClient/GetPdfStatus";
import type { RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/fetch";

function getGetPdfStatusUrl(project_uuid: GetPdfStatusPathParams["project_uuid"], file_uuid: GetPdfStatusPathParams["file_uuid"]) {
  const res = { method: 'GET', url: `/v1/pdf/${project_uuid}/${file_uuid}/status` as const }  
  return res
}

/**
 * @description Returns a JSON object with the status of the PDF regarding processing and availability of the PDF file.
 * @summary Get the status of a PDF
 * {@link /v1/pdf/:project_uuid/:file_uuid/status}
 */
export async function getPdfStatus(project_uuid: GetPdfStatusPathParams["project_uuid"], file_uuid: GetPdfStatusPathParams["file_uuid"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetPdfStatusQueryResponse, ResponseErrorConfig<GetPdfStatus422>, unknown>({ method : "GET", url : getGetPdfStatusUrl(project_uuid, file_uuid).url.toString(), ... requestConfig })  
  return res.data
}